import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Image1 from 'Components/ComponentLibrary/Components/Media/Images/Image1';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const FinancialInstitutionImage = ({
  className,
  classes,
  src,
  alt,
  ...rest
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Image1
        src={src}
        alt={alt}
        {...rest}
      />
    </Box>
  );
};

FinancialInstitutionImage.defaultProps = {
  className: '',
  alt: 'Financial Institution Logo',
};

FinancialInstitutionImage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default withStyles(styles)(FinancialInstitutionImage);
